module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"download":"herunterladen","Drag to reorder":"Reihenfolge per Drag & Drop ändern"}}')
  delete Component.options._Ctor
}
